import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTodaySales, salesExcelReports, viewReports } from '../../../redux/actions/Report.action';
import { IoSearchOutline } from 'react-icons/io5';
import { FiTarget } from 'react-icons/fi';
import { Button, Modal } from 'react-bootstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { BsDownload } from 'react-icons/bs';
import * as XLSX from 'xlsx';
import debounce from 'lodash/debounce';

export default function SalesReport() {
    const dispatch = useDispatch();
    const reportData = useSelector((state) => state.report);
    const [formData, setFormData] = useState({
        date: '',
        startDate: '',
        endDate: '',
        type: '',
        paymentType: '',
        search: '',
    });
    const [inputValue, setInputValue] = useState(''); // Separate state for search input
    const [reportModal, setReportModal] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    console.log("reportData",reportData);
    const reportToggle = () => {
        setReportModal(!reportModal);
    };

    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const handleFormData = (e) => {
        const { name, value } = e.target;
        if (name === 'search') {
            setInputValue(value);
            handleSearch(value);
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
                ...(name === 'startDate' || name === 'endDate' ? { date: '' } : {}),
                ...(name === 'date' ? { startDate: '', endDate: '' } : {}),
            }));
        }
    };

    const handleSearch = useCallback(
        debounce((value) => {
            setFormData((prev) => ({
                ...prev,
                search: value,
            }));
            setMainPage(1); // Reset to page 1 on new search
        }, 300),
        []
    );

    const handleReport = (billNo) => {
        const payload = {
            billNumber: billNo,
        };
        dispatch(viewReports(payload));
    };

    const ChangeMainPage = ({ selected }) => {
        setMainPage(selected + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const totalRecords = reportData?.todaySales?.data?.total || 0;
    const PageCount = Math.ceil(totalRecords / rowsPerPage);

    useEffect(() => {
        let payload = {};
        if (formData.date) {
            payload.date = formData.date;
        }
        if (formData.startDate || formData.endDate) {
            payload.startDate = formData.startDate;
            payload.endDate = formData.endDate;
        }
        if (formData.type) {
            payload.type = formData.type;
        }
        if (formData.paymentType) {
            payload.paymentType = formData.paymentType;
        }

        setIsLoading(true);
        dispatch(getTodaySales(formData.search, limits, payload))
        dispatch(salesExcelReports(formData.search, payload))
            .finally(() => setIsLoading(false));
    }, [formData, mainPage, rowsPerPage, dispatch]);

    const handleExport = () => {
        const data = {
            date: formData.date,
            startDate: formData.startDate,
            endDate: formData.endDate,
            type: formData.type,
            paymentType: formData.paymentType,
        };
        dispatch(salesExcelReports(formData.search, data));
        setIsExporting(true);
    };

    useEffect(() => {
        if (isExporting && reportData?.getSalesExcelData?.data?.data?.length) {
            const exportData = reportData?.getSalesExcelData?.data?.data?.map((item) => ({
                "Date": item.date ? moment(item.date).format('DD/MM/YYYY') : '',
                "Bill No": item.billNo,
                "Name": item.patientName,
                "Phone Number": item.phoneNumber,
                "Service Name": item.packageName || item.serviceName || '-',
                "Rate": item.rate||'-',
                "Bill Type": item.billType,
                "Payment Type": item.paymentMethod,
                "Total Amount": item.totalAmount,
                "Paid Amount": item.paidAmount,
                "Due Amount": item.dueAmount,
                "Branch": item.branch,
                "User": item.billGenerateBy,
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sales Report");

            XLSX.writeFile(wb, "Sales_Report.xlsx");
            setIsExporting(false);
        }
    }, [reportData?.getSalesExcelData?.data?.data, isExporting]);

    // Memoize table rows to prevent unnecessary re-renders
    const tableRows = useMemo(() => {
        if (reportData?.todaySales?.data?.data?.length > 0) {
            return reportData.todaySales.data.data.map((res) => (
                <Tr key={res._id}>
                    <Td>{res.date ? moment(res.date).format('DD/MM/YYYY') : '-'}</Td>
                    <Td>{res.billNo || '-'}</Td>
                    <Td className='capitalize'>{res.patientName || '-'}</Td>
                    <Td>{res.phoneNumber || '-'}</Td>
                    <Td>{res.packageName || res.serviceName || ' - '}</Td>
                    <Td>{res.serviceRate || '-'}</Td>
                    <Td>{res.billType || '-'}</Td>
                    <Td>{res.paymentMethod || '-'}</Td>
                    <Td>{res.totalAmount || '-'}</Td>
                    <Td>{res.paidAmount || '-'}</Td>
                    <Td>{res.dueAmount || '-'}</Td>
                    <Td>{res.branch || '-'}</Td>
                    <Td>{res.billGenerateBy || '-'}</Td>
                    <Td>
                        <FiTarget
                            className='text-primary text-xl cursor-pointer'
                            title='view'
                            onClick={() => { reportToggle(); handleReport(res.billNo); }}
                        />
                    </Td>
                </Tr>
            ));
        }
        return (
            <Tr>
                <Td colSpan={13} textAlign={'center'}>No any report</Td>
            </Tr>
        );
    }, [reportData?.todaySales?.data?.data]);

    return (
        <>
            <div className="mt-[100px]">
                <div className="d-flex items-center gap-3">
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Date</label>
                        <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleFormData}
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Start Date</label>
                        <input
                            type="date"
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleFormData}
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">End Date</label>
                        <input
                            type="date"
                            name="endDate"
                            value={formData.endDate}
                            onChange={handleFormData}
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Service</label>
                        <select
                            value={formData.type}
                            name='type'
                            onChange={handleFormData}
                            className="!border-b w-full focus:outline-none"
                        >
                            <option value="">Select Service</option>
                            <option value="FILECHARGE">File Charge</option>
                            <option value="CONSULTANT">Consultation</option>
                            <option value="SERVICE">Services</option>
                            <option value="PACKAGE">Package</option>
                        </select>
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Payment Type</label>
                        <select
                            value={formData.paymentType}
                            name='paymentType'
                            onChange={handleFormData}
                            className="!border-b w-full focus:outline-none"
                        >
                            <option value="">Select Type</option>
                            <option value="Pending">Pending</option>
                            <option value="Cash">Cash</option>
                            <option value="Online">Online</option>
                            <option value="Credit Card / Debit Card">Credit Card / Debit Card</option>
                            <option value="Online (Gpay)">Online (Gpay)</option>
                            <option value="Net banking">Net banking</option>
                        </select>
                    </div>
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={inputValue}
                            onChange={handleFormData}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <div className="me-2">
                        <Button
                            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                            onClick={handleExport}
                        >
                            <BsDownload className="mt-1 me-2" />
                            Download
                        </Button>
                    </div>
                </div>

                <div className='col-6 text-end ms-auto mt-4'>
                    <div className='flex justify-end gap-3 font-medium text-lg'>
                        <label className='text-center block text-gray-600 border-r pe-3'>
                            <span>Total Records :</span>{' '}
                            <span className='ms-1 border-b border-gray-600'>{reportData?.todaySales?.data?.total}</span>
                        </label>
                        <label className='text-center block text-gray-600 border-r pe-3'>
                            <span>Net Amount :</span>{' '}
                            <span className='ms-1 border-b border-gray-600'>{reportData?.todaySales?.data?.totals?.overallTotalAmount}</span>
                        </label>
                        <Link to='/master/PaidAmountReport' className='text-center block text-success border-r pe-3'>
                            <span>Received Amount : </span>{' '}
                            <span className='ms-1 border-b border-success'>{reportData?.todaySales?.data?.totals?.overallPaidAmount}</span>
                        </Link>
                        <Link to='/master/DueAmount' className='text-center block text-danger'>
                            <span>Due Amount : </span>{' '}
                            <span className='ms-1 border-b border-danger'>{reportData?.todaySales?.data?.totals?.overallDueAmount}</span>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Date</Th>
                                <Th>Bill No</Th>
                                <Th>Name</Th>
                                <Th>Phone Number</Th>
                                <Th>Service Name</Th>
                                <Th>Rate</Th>
                                <Th>Bill Type</Th>
                                <Th>Payment Type</Th>
                                <Th>Total Amount</Th>
                                <Th>Paid amount</Th>
                                <Th>Due amount</Th>
                                <Th>Branch</Th>
                                <Th>User</Th>
                                <Th>Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {isLoading ? (
                                <Tr>
                                    <Td colSpan={13} textAlign={'center'}>Loading...</Td>
                                </Tr>
                            ) : tableRows}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
            <div className="d-flex align-items-center gap-2 mb-3">
                Rows per page:
                <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    className="ms-2 border rounded-md focus:outline-none"
                >
                    <option value={10}>10</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                </select>
            </div>
            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            <Modal show={reportModal} size="lg" onHide={reportToggle} centered>
                <Modal.Body className='p-3'>
                    <Table>
                        <Thead>
                            <Tr>
                                <Th>Payment Date</Th>
                                <Th>Payment Time</Th>
                                <Th>Paid Amount</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {reportData?.viewReport?.data?.history?.map((res) =>
                                res?.history?.map((item) => (
                                    <Tr key={item._id}>
                                        <Td>{item.paymentDate ? moment(item.paymentDate).format('DD/MM/YYYY') : ''}</Td>
                                        <Td>{item.paymentDate ? moment(item.paymentDate).format('hh:mm A') : ''}</Td>
                                        <Td>{item.amount}</Td>
                                    </Tr>
                                ))
                            )}
                        </Tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer className='border-0'>
                    <Button
                        variant="secondary"
                        onClick={reportToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}